import { render, staticRenderFns } from "./CallReceived.vue?vue&type=template&id=2d443382&"
import script from "./CallReceived.vue?vue&type=script&lang=js&"
export * from "./CallReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports